import { Stack } from "@mui/material";
import { styled } from "@mui/material/styles";
import { BodyTextM, BodyTextS } from "../Typography";

export const FufiTransactionRowContainer = styled(Stack)(() => ({
    flexDirection: "row",
    alignItems: "center",
    gap: 16,
}));

export const FufiTransactionRowContent = styled(Stack)(() => ({
    flexGrow: 1,
}));

export const FufiTransactionRowTitle = styled(BodyTextM)(() => ({}));

export const FufiTransactionRowSubtitle = styled(BodyTextS)(({ theme }) =>
    theme.unstable_sx({
        mb: 0,
    }),
);

export const FufiTransactionRowAmount = styled(BodyTextM)(() => ({
    whiteSpace: "nowrap",
}));
